export class CostTypeDTO {
    id!: number;
    name?: string;
    description?: string;
    sortOrder?: number;
    isActive?: boolean;
    QuantityType?: string;
    PerformanceCriteria?: any[];
  }